export class ACLFeature {
  static MAINTENANCE_MODE_ADMIN = 'MAINTENANCE_MODE_ADMIN';
  static GENERATE_M1_FEATURE_FILE = 'GENERATE_M1_FEATURE_FILE';
  static ACCESS_SUPER_ADMIN_TAB = 'ACCESS_SUPER_ADMIN_TAB';
  static IMPERSONATE = 'IMPERSONATE';
  static ADMIN_PANEL = 'ADMIN_PANEL';
  static WHITELIST = 'WHITELIST';
  static WHITELIST_READ = 'WHITELIST_READ';
  static WHITELIST_READ_ALL = 'WHITELIST_READ_ALL';
  static WHITELIST_WRITE = 'WHITELIST_WRITE';
  static EDIT_DRIVERS = 'EDIT_DRIVERS';
  static READ_DRIVERS = 'READ_DRIVERS';
  static WRITE_DRIVERS = 'WRITE_DRIVERS';
  static EDIT_MODULES = 'EDIT_MODULES';
  static READ_MODULES = 'READ_MODULES';
  static WRITE_MODULES = 'WRITE_MODULES';
  static EDIT_BRIDGES = 'EDIT_BRIDGES';
  static READ_BRIDGES = 'READ_BRIDGES';
  static WRITE_BRIDGES = 'WRITE_BRIDGES';
  static READ_SENSORS = 'READ_SENSORS';
  static WRITE_SENSORS = 'WRITE_SENSORS';
  static READ_SENSORS_WHITELIST = 'READ_SENSORS_WHITELIST';
  static WRITE_SENSORS_WHITELIST = 'WRITE_SENSORS_WHITELIST';
  static READ_SENSORS_WHITELIST_ALL_COMPANIES = 'READ_SENSORS_WHITELIST_ALL_COMPANIES';
  static READ_SENSOR_ACCESSORIES = 'READ_SENSORS';
  static WRITE_SENSOR_ACCESSORIES = 'WRITE_SENSORS';
  static GLOBAL_REGION_FLUSH = 'GLOBAL_REGION_FLUSH';
  static REGION_FLUSH = 'REGION_FLUSH';
  static COMPANY_FLUSH = 'COMPANY_FLUSH';
  static ROYAL_FLUSH = 'ROYAL_FLUSH';
  static SPC_FLUSH = 'SPC_FLUSH';
  static SHOW_DOWNLOAD_BUTTON = 'SHOW_DOWNLOAD_BUTTON';
  static ENABLE_HAS_MATCHING_DRIVER_FILTER = 'ENABLE_HAS_MATCHING_DRIVER_FILTER';
  static ENABLE_WHITELISTING_FILTER = 'ENABLE_WHITELISTING_FILTER';
  static ASSUME_ROLE = 'ASSUME_ROLE';
  static DOWNLOAD_CSV_TEMPLATE = 'DOWNLOAD_CSV_TEMPLATE';
  static CAN_SEE_COMPANY_PORTFOLIO = 'CAN_SEE_COMPANY_PORTFOLIO';
  static EXPORT_EXCEL_REGIONIZED_MODULE_PORTFOLIO = 'EXPORT_EXCEL_REGIONIZED_MODULE_PORTFOLIO';
  static EXPORT_EXCEL_REGIONIZED_DRIVER_PORTFOLIO = 'EXPORT_EXCEL_REGIONIZED_DRIVER_PORTFOLIO';
  static EXPORT_USER_CATALOG = 'EXPORT_USER_CATALOG';
  static EXPORT_ACL_MATRIX = 'EXPORT_ACL_MATRIX';
  static ARCHIVE = 'ARCHIVE';
  static VIEW_ARCHIVE_IN_ADMIN = 'VIEW_ARCHIVE_IN_ADMIN';
  static IMPORT_LABELING_SHEET = 'IMPORT_LABELING_SHEET';
  static EXPORT_LABELING_SHEET = 'EXPORT_LABELING_SHEET';
  static READ_TAGS = 'READ_TAGS';
  static WRITE_TAGS = 'WRITE_TAGS';
}



// WEBPACK FOOTER //
// ./src/app/_models/acl-feature.ts